/* BFND landing pages: countdown + gallery. Guarded so several sections can load this file. */
(function () {
  function pad(n) { return String(n).padStart(2, '0'); }

  function nextMidnightIn(tz) {
    var now = new Date();
    var zoned = new Date(now.toLocaleString('en-US', { timeZone: tz || 'America/Los_Angeles' }));
    var mid = new Date(zoned);
    mid.setHours(24, 0, 0, 0);
    return now.getTime() + (mid - zoned);
  }

  if (!customElements.get('bfnd-countdown')) {
    customElements.define('bfnd-countdown', class extends HTMLElement {
      connectedCallback() {
        this.mode = this.dataset.mode || 'midnight';
        this.tz = this.dataset.tz || 'America/Los_Angeles';
        this.end = this.resolveEnd();
        this.tick = this.tick.bind(this);
        this.tick();
        this.timer = setInterval(this.tick, 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      resolveEnd() {
        if (this.mode === 'date' && this.dataset.end) {
          var t = Date.parse(this.dataset.end);
          if (!isNaN(t)) return t;
        }
        return nextMidnightIn(this.tz);
      }
      tick() {
        if (this.end <= Date.now()) {
          if (this.mode === 'date') {
            this.render(0);
            clearInterval(this.timer);
            if (this.dataset.hideOnEnd === 'true') {
              var host = this.closest('[data-bfnd-hide-on-end]') || this;
              host.hidden = true;
            }
            return;
          }
          this.end = nextMidnightIn(this.tz);
        }
        this.render(Math.max(0, Math.floor((this.end - Date.now()) / 1000)));
      }
      render(s) {
        var v = { h: pad(Math.floor(s / 3600)), m: pad(Math.floor((s % 3600) / 60)), s: pad(s % 60) };
        this.querySelectorAll('[data-cd]').forEach(function (el) { el.textContent = v[el.dataset.cd]; });
        this.querySelectorAll('[data-cd-full]').forEach(function (el) { el.textContent = v.h + ':' + v.m + ':' + v.s; });
      }
    });
  }

  if (!customElements.get('bfnd-gallery')) {
    customElements.define('bfnd-gallery', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.main = this.querySelector('.bfnd-gallery__main');
        this.querySelectorAll('[data-bfnd-thumb]').forEach(function (btn) {
          btn.addEventListener('click', function () { self.select(btn); });
        });
      }
      select(btn) {
        if (!this.main) return;
        if (btn.dataset.srcset) this.main.srcset = btn.dataset.srcset;
        this.main.src = btn.dataset.src;
        this.main.alt = btn.dataset.alt || '';
        this.querySelectorAll('[data-bfnd-thumb]').forEach(function (b) {
          b.setAttribute('aria-current', b === btn ? 'true' : 'false');
        });
      }
    });
  }
})();
